module.exports = __webpack_public_path__ + "img/logoload2.e2ad7ca6.svg";